import { makeAutoObservable } from "mobx";

class ProfileStore {
  xp = 0;
  sections = [];
  schools = [];
  careerClimbs = [];
  messages = [];
  districts = [];

  constructor() {
    makeAutoObservable(this);
    this.loadFromLocalStorage();
  }

  setXP(amount) {
    this.xp = amount;
    this.saveToLocalStorage();
  }

  addXP(amount) {
    this.xp += amount;
    this.saveToLocalStorage();
  }

  setDistricts(districts) {
    this.districts = districts;
    this.saveToLocalStorage();
  }

  getDistrictById(id) {
    return this.districts.find((district) => district.id === id);
  }

  setSchools(schools) {
    this.schools = schools;
    this.saveToLocalStorage();
  }

  getSchoolById(id) {
    return this.schools.find((school) => school.id === id);
  }

  setSections(sections) {
    this.sections = sections;
    this.saveToLocalStorage();
  }

  getSectionById(id) {
    return this.sections.find((section) => section.id === id);
  }

  getCareerClimbById(id) {
    return this.careerClimbs.find((cc) => cc.id === id);
  }

  setMessages(messages) {
    this.messages = messages;
    this.saveToLocalStorage();
  }

  getMessagesById(id) {
    return this.messages.find((m) => m.id === id);
  }

  markMessageAsRead(messageId, userID) {
    const message = this.messages.find((msg) => msg.id === messageId);
    if (message) {
      if (!message.readBy) {
        message.readBy = []; // Ensure readBy is an array
      }

      if (!message.readBy.includes(userID)) {
        message.readBy = [...message.readBy, userID]; // Spread to maintain observability
        this.messages = [...this.messages]; // Reassign to trigger MobX observability
        this.saveToLocalStorage();
      }
    }
  }

  getCareerClimbByLearnosityTag(tag) {
    return this.careerClimbs.find((cc) => cc.learnosityTag === tag);
  }

  setCareerClimbs(climbs) {
    this.careerClimbs = climbs;
    this.saveToLocalStorage();
  }

  updateCareerClimbs(id, newClimb) {
    const index = this.careerClimbs.findIndex(
      (careerClimb) => careerClimb.id === id,
    );
    if (index !== -1) {
      this.careerClimbs[index] = newClimb; // Direct update
    }
    this.saveToLocalStorage();
  }

  saveToLocalStorage() {
    localStorage.setItem(
      "profile",
      JSON.stringify({
        xp: this.xp,
        districts: this.districts,
        schools: this.schools,
        sections: this.sections,
        careerClimbs: this.careerClimbs,
        messages: this.messages,
      }),
    );
  }

  loadFromLocalStorage() {
    const storedProfile = localStorage.getItem("profile");
    if (storedProfile) {
      const { sections, careerClimbs, messages, schools, districts } =
        JSON.parse(storedProfile);
      this.districts = districts;
      this.schools = schools;
      this.sections = sections;
      this.careerClimbs = careerClimbs;
      this.messages = messages;
    }
  }

  clearProfile() {
    this.xp = 0;
    this.sections = [];
    this.schools = [];
    this.careerClimbs = [];
    this.messages = [];
    this.districts = [];
    localStorage.removeItem("profile");
  }
}

const profileStore = new ProfileStore();
export default profileStore;
